import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import CustomModalView from '../../../common/input/customModal/customModalView';
import { Navigate } from 'react-router-dom';

const AdminSummaryView = (props) => {
  if (localStorage.getItem('token') != null) {
    return (
      <>
        <div className="registration-form_main">
          <div
            className="registration-form_wrapper"
            style={{ padding: '78px 73px' }}
          >
            <div className="dashboard-body-area" style={{ width: '100%' }}>
              <section className="dashboard-page-title">
                <h2>
                  The following details have been temporarily saved to the
                  system,but Your application is not been submmited yet.Please
                  take a moment to review the details below then follow the
                  instructions at the bottom of the page.
                </h2>
              </section>
              <section className="dashboard-page-title">
                <h2>
                  <strong>Step 1: Personal Details Summary </strong>
                </h2>
              </section>
              <div style={{ marginTop: '30px' }}>
                <Table responsive>
                  <tbody>
                    <tr>
                      <td style={{ minWidth: '15em' }}>First Name</td>
                      <td>
                        <span className="title-crop">
                          {props.perssonal_detail.first_name}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Last Name</td>
                      <td>
                        <span className="title-crop">
                          {props.perssonal_detail.last_name}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Email Address</td>
                      <td>
                        <span className="title-crop">
                          {props.perssonal_detail.email}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Job Title</td>
                      <td>
                        <span className="title-crop">{props.title_type}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Date of Birth</td>
                      <td>
                        <span className="title-crop">
                          {props.formated_date}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Country</td>
                      <td>
                        <span className="title-crop">
                          {props.perssonal_detail.country}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>City</td>
                      <td>
                        <span className="title-crop">
                          {props.perssonal_detail.city}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Zip Code</td>
                      <td>
                        <span className="title-crop">
                          {props.perssonal_detail.zipcode}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Address</td>
                      <td>
                        <span className="title-crop">
                          {props.perssonal_detail.address}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>
                        Do you have a right to work in the UK
                      </td>
                      <td>
                        <span className="title-crop">
                          {props.right_to_work_selected}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Cv Uploaded</td>
                      <td>
                        <span className="title-crop">{props.file_name}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Organization</td>
                      <td>
                        <span className="title-crop">{props.Organization}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>last work date</td>
                      <td>
                        <span className="title-crop">
                          {props.experience_last_worked_date}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Passport</td>
                      <td>
                        <span className="title-crop">
                          {props.passport_number}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Licence</td>
                      <td>
                        <span className="title-crop">
                          {props.licence_number}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Ni Number</td>
                      <td>
                        <span className="title-crop">{props.ni_number}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Qualification</td>
                      <td>
                        <span className="title-crop">
                          {props.educational_qualification}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>School Name</td>
                      <td>
                        <span className="title-crop">{props.school_name}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>
                        Qualification Completion Year
                      </td>
                      <td>
                        <span className="title-crop">
                          {props.completion_year}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      {props.nationality ? (
                        <>
                          <td style={{ minWidth: '15em' }}>UK Nationality</td>
                          <td>
                            <span className="title-crop">True</span>
                          </td>
                        </>
                      ) : (
                        <>
                          <td style={{ minWidth: '15em' }}>UK Nationality</td>
                          <td>
                            <span className="title-crop">False</span>
                          </td>
                        </>
                      )}
                    </tr>
                    <tr>
                      <td style={{ minWidth: '15em' }}>Care Type</td>
                      <td>
                        <span className="title-crop">{props.care_type}</span>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              <section className="dashboard-page-title">
                <h2>
                  <strong>Step 2: Professional Details Summary </strong>
                </h2>
              </section>
              <div style={{ marginTop: '30px' }}>
                {props.professional_profile.map(
                  (professional_profile, index) => (
                    <Table responsive>
                      <tbody>
                        <tr>
                          <td style={{ minWidth: '15em' }}>Index</td>
                          <td>
                            <span className="title-crop">{index}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ minWidth: '15em' }}>
                            Professional Qualification
                          </td>
                          <td>
                            <span className="title-crop">
                              {professional_profile.professional_qualification}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ minWidth: '15em' }}>Issued By</td>
                          <td>
                            <span className="title-crop">
                              {professional_profile.professional_issued_by}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ minWidth: '15em' }}>Expires On</td>
                          <td>
                            <span className="title-crop">
                              {professional_profile.professional_expires_on}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )
                )}
              </div>
              <section className="dashboard-page-title">
                <h2>
                  <strong>Step 1: Availablity </strong>
                </h2>
              </section>
              <div style={{ marginTop: '30px' }}>
                <Table responsive>
                  {props.Availablity.map((availablity, index) => (
                    <tbody>
                      <tr>
                        <td style={{ minWidth: '15em' }}>Index</td>
                        <td>
                          <span className="title-crop">{index}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: '15em' }}>Day</td>
                        <td>
                          <span className="title-crop">{availablity.time}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ minWidth: '15em' }}>Time</td>
                        <td>
                          <span className="title-crop">{availablity.day}</span>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </Table>
              </div>
              <section
                className="dashboard-page-title"
                style={{ marginTop: '10px' }}
              >
                <h2>
                  If any of the details are incorrect please hit the edit button{' '}
                </h2>
                <div
                  style={{
                    padding: '11px 0',
                    width: '350px',
                    margin: '0px 0px',
                  }}
                >
                  <form>
                    <div
                      className="form-btn_group"
                      style={{ textAlign: 'start' }}
                    >
                      <a href="/registration/submit-cv/#edit">
                        <button
                          type="button"
                          style={{ width: '285px' }}
                          className="btn btn-border"
                        >
                          Edit <i className="fa fa-pencil-square-o"></i>
                        </button>
                      </a>
                    </div>
                  </form>
                </div>
              </section>
              <section
                className="dashboard-page-title"
                style={{ marginTop: '10px' }}
              >
                <h2>If These are correct please hit the submit button</h2>
                <div
                  className="login-form"
                  style={{
                    padding: '11px 0',
                    width: '286px',
                    margin: '0px 0px',
                  }}
                >
                  <form>
                    <div className="field-box">
                      <a href="/registration/cv-complete">
                        <button type="button">
                          Submit<i className="fa fa-sign-in"></i>
                        </button>
                      </a>
                    </div>
                  </form>
                </div>
              </section>
            </div>
          </div>
        </div>
        <CustomModalView
          modal_show={props.modal_show}
          authResponse={props.authResponse}
          showCustomModal={props.showCustomModal}
          hideCustomModal={props.hideCustomModal}
        />
      </>
    );
  } else {
    return <Navigate to="/login" />;
  }
};

export default AdminSummaryView;
